module.exports = __webpack_public_path__ + "static/media/sitting-sitting-on-the-ground-sitting-up-svgrepo-com.b3b23335.svg";